import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Pencil, Trash2, FolderTree } from "lucide-react";
import { DashboardLayout } from "../../components/DashboardLayout";
import { EmptyState } from "../../components/Common";
import { ADMIN_MENU } from "../../lib/menus";
import api, { apiError } from "../../lib/api";

export default function AdminCategories() {
  const [rows, setRows] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ name: "", description: "", is_active: true });

  const load = () => api.get("/categories?all=true").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { document.title = "Kategori - DS KODE"; load(); }, []);

  const open = (c) => { setModal(c || {}); setForm(c ? { name: c.name, description: c.description || "", is_active: c.is_active } : { name: "", description: "", is_active: true }); };

  const save = async (e) => {
    e.preventDefault();
    try {
      if (modal.id) await api.put(`/categories/${modal.id}`, form);
      else await api.post("/categories", form);
      toast.success("Kategori disimpan");
      setModal(null);
      load();
    } catch (err) { toast.error(apiError(err)); }
  };

  const del = async (id) => {
    if (!window.confirm("Hapus kategori ini?")) return;
    try { await api.delete(`/categories/${id}`); toast.success("Kategori dihapus"); load(); } catch { toast.error("Gagal"); }
  };

  return (
    <DashboardLayout title="Kelola Kategori" menu={ADMIN_MENU} testid="admin-categories">
      <div className="flex justify-end mb-5"><button onClick={() => open(null)} data-testid="add-category-btn" className="btn-primary"><Plus className="h-4 w-4" /> Tambah Kategori</button></div>

      {rows === null ? <div className="h-64 skeleton rounded-xl" /> : rows.length === 0 ? <EmptyState icon={FolderTree} title="Belum ada kategori." /> : (
        <div className="card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[500px]">
              <thead className="bg-slate-50 border-b border-slate-200"><tr><th className="th">Nama</th><th className="th">Produk</th><th className="th">Status</th><th className="th text-right">Aksi</th></tr></thead>
              <tbody className="divide-y divide-slate-100">
                {rows.map((c) => (
                  <tr key={c.id} data-testid={`category-row-${c.id}`}>
                    <td className="td font-medium text-slate-900">{c.name}</td>
                    <td className="td">{c.product_count}</td>
                    <td className="td"><span className={`text-xs font-semibold ${c.is_active ? "text-emerald-600" : "text-slate-400"}`}>{c.is_active ? "Aktif" : "Nonaktif"}</span></td>
                    <td className="td"><div className="flex justify-end gap-2"><button onClick={() => open(c)} data-testid={`edit-category-${c.id}`} className="p-2 rounded-lg hover:bg-slate-100 text-slate-500"><Pencil className="h-4 w-4" /></button><button onClick={() => del(c.id)} data-testid={`delete-category-${c.id}`} className="p-2 rounded-lg hover:bg-red-50 text-red-500"><Trash2 className="h-4 w-4" /></button></div></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {modal && (
        <div className="fixed inset-0 z-[100] grid place-items-center p-4 bg-slate-900/50 backdrop-blur-sm" onClick={() => setModal(null)}>
          <form onSubmit={save} className="bg-white rounded-2xl p-6 max-w-sm w-full space-y-4" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-heading font-bold text-slate-900">{modal.id ? "Edit" : "Tambah"} Kategori</h3>
            <div><label className="text-sm font-medium text-slate-700">Nama</label><input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input mt-1" data-testid="cat-name" /></div>
            <div><label className="text-sm font-medium text-slate-700">Deskripsi</label><input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="input mt-1" /></div>
            <label className="flex items-center gap-2 text-sm text-slate-700"><input type="checkbox" checked={form.is_active} onChange={(e) => setForm({ ...form, is_active: e.target.checked })} className="rounded" /> Aktif</label>
            <div className="flex gap-2"><button type="button" onClick={() => setModal(null)} className="btn-outline flex-1">Batal</button><button type="submit" data-testid="cat-save" className="btn-primary flex-1">Simpan</button></div>
          </form>
        </div>
      )}
    </DashboardLayout>
  );
}
